(function (root) {
  'use strict';

  function clampNumber(value, min, max, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? Math.min(max, Math.max(min, number)) : fallback;
  }

  function buildJudgeMeUrl(config) {
    var url = new URL('https://judge.me/api/v1/widgets/product_review');
    url.searchParams.set('shop_domain', String(config.shopDomain || '').trim());
    url.searchParams.set('api_token', String(config.publicToken || '').trim());
    url.searchParams.set('external_id', String(config.externalId || '').trim());
    url.searchParams.set('page', '1');
    url.searchParams.set('per_page', String(clampNumber(config.limit, 1, 24, 12)));
    return url.toString();
  }

  function selectAutomaticReviews(reviews, minimumRating, limit) {
    var selected = [];
    var seen = new Set();
    var minimum = clampNumber(minimumRating, 1, 5, 1);
    var maximum = clampNumber(limit, 1, 24, 12);
    for (var index = 0; index < reviews.length && selected.length < maximum; index += 1) {
      var review = reviews[index] || {};
      var id = String(review.id || 'review-' + index);
      var hasContent = Boolean(String(review.title || '').trim() || String(review.body || '').trim() || String(review.image || '').trim());
      if (!hasContent || Number(review.rating || 0) < minimum || seen.has(id)) continue;
      seen.add(id);
      selected.push(review);
    }
    return selected;
  }

  function cleanText(element) {
    return element ? String(element.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function safeImageUrl(value) {
    var source = String(value || '').trim();
    if (source.indexOf('//') === 0) return 'https:' + source;
    if (/^https:\/\//i.test(source)) return source;
    return '';
  }

  function extractJudgeMeReviews(markup, productLabel) {
    if (typeof DOMParser === 'undefined') return [];
    var documentNode = new DOMParser().parseFromString(String(markup || ''), 'text/html');
    return Array.from(documentNode.querySelectorAll('.jdgm-rev')).map(function (node, index) {
      var ratingNode = node.querySelector('.jdgm-rev__rating');
      var imageNode = node.querySelector('.jdgm-rev__pic-img, .jdgm-rev__pic-link img');
      var identifier = node.getAttribute('data-review-id') || node.id || 'judgeme-' + index;
      return {
        id: 'judgeme-' + identifier,
        source: 'judgeme',
        rating: clampNumber(ratingNode && ratingNode.getAttribute('data-score'), 1, 5, 0),
        title: cleanText(node.querySelector('.jdgm-rev__title')),
        body: cleanText(node.querySelector('.jdgm-rev__body')),
        author: cleanText(node.querySelector('.jdgm-rev__author')) || 'Customer',
        verified: Boolean(node.querySelector('.jdgm-rev__buyer-badge, .jdgm-rev__buyer-badge-wrapper')),
        date: cleanText(node.querySelector('.jdgm-rev__timestamp')),
        image: safeImageUrl(imageNode && (imageNode.getAttribute('data-src') || imageNode.getAttribute('src'))),
        productLabel: productLabel || ''
      };
    });
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== '') node.textContent = text;
    return node;
  }

  function createReviewCard(review, config) {
    var card = element('article', 'pl-reviews-2__card');
    card.dataset.plReviews2Card = '';
    card.dataset.source = review.source || 'judgeme';
    card.dataset.reviewId = review.id;

    var top = element('div', 'pl-reviews-2__topline');
    var stars = element('span', 'pl-reviews-2__stars', '★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating)));
    stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
    top.append(stars);
    if (review.verified && config.showVerified) top.append(element('span', 'pl-reviews-2__verified', '✓ ' + config.verifiedLabel));
    card.append(top);

    if (review.image && config.showImages) {
      var image = element('img', 'pl-reviews-2__image');
      image.src = review.image;
      image.alt = review.title || 'Customer review image';
      image.loading = 'lazy';
      card.append(image);
    }
    if (review.title) card.append(element('h3', 'pl-reviews-2__title', review.title));
    if (review.body) card.append(element('div', 'pl-reviews-2__body', review.body));

    var footer = element('footer', 'pl-reviews-2__footer');
    footer.append(element('span', 'pl-reviews-2__avatar pl-reviews-2__avatar--initial', (review.author || 'C').slice(0, 1).toUpperCase()));
    var identity = element('span', 'pl-reviews-2__identity');
    identity.append(element('strong', '', review.author || 'Customer'));
    if (review.date) identity.append(element('span', '', review.date));
    if (review.productLabel) identity.append(element('span', '', review.productLabel));
    footer.append(identity);
    card.append(footer);
    return card;
  }

  function readConfig(section) {
    return {
      enabled: section.dataset.plReviews2Enabled === 'true',
      publicToken: section.dataset.plReviews2Token || '',
      shopDomain: section.dataset.plReviews2Shop || '',
      externalId: section.dataset.plReviews2ProductId || '',
      productLabel: section.dataset.plReviews2ProductLabel || '',
      limit: clampNumber(section.dataset.plReviews2Limit, 1, 24, 12),
      minimumRating: clampNumber(section.dataset.plReviews2MinRating, 1, 5, 1),
      showImages: section.dataset.plReviews2ShowImages === 'true',
      showVerified: section.dataset.plReviews2ShowVerified === 'true',
      verifiedLabel: 'Verified Buyer',
      autoplay: section.dataset.plReviews2Autoplay === 'true',
      interval: clampNumber(section.dataset.plReviews2Interval, 3000, 12000, 6000),
      editor: section.dataset.plReviews2Editor === 'true'
    };
  }

  function setEditorStatus(section, message, allowRetry) {
    if (section.dataset.plReviews2Editor !== 'true') return;
    var status = section.querySelector('[data-pl-reviews-2-status]');
    var retry = section.querySelector('[data-pl-reviews-2-retry]');
    if (status) status.textContent = message;
    if (retry) retry.hidden = !allowRetry;
  }

  function removeSkeletons(section) {
    section.querySelectorAll('[data-pl-reviews-2-skeleton]').forEach(function (node) { node.remove(); });
  }

  async function loadJudgeMe(section, force) {
    if (section.dataset.plReviews2Loading === 'true') return;
    if (!force && section.dataset.plReviews2Loaded === 'true') return;
    var config = readConfig(section);
    if (!config.enabled) {
      removeSkeletons(section);
      return;
    }
    section.dataset.plReviews2Loading = 'true';
    setEditorStatus(section, 'Loading Judge.me reviews…', false);
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 9000);
    try {
      var response = await fetch(buildJudgeMeUrl(config), { signal: controller.signal, credentials: 'omit', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Judge.me returned HTTP ' + response.status);
      var contentType = response.headers.get('content-type') || '';
      var markup = '';
      if (contentType.indexOf('application/json') !== -1) {
        var payload = await response.json();
        markup = payload.widget || payload.html || payload.data || '';
      } else {
        markup = await response.text();
      }
      var reviews = selectAutomaticReviews(extractJudgeMeReviews(markup, config.productLabel), config.minimumRating, config.limit);
      var track = section.querySelector('[data-pl-reviews-2-track]');
      removeSkeletons(section);
      reviews.forEach(function (review) { track.append(createReviewCard(review, config)); });
      section.dataset.plReviews2Loaded = 'true';
      setEditorStatus(section, reviews.length ? reviews.length + ' Judge.me reviews loaded.' : 'No matching published Judge.me reviews were found for this product.', false);
    } catch (error) {
      removeSkeletons(section);
      setEditorStatus(section, 'Judge.me reviews could not be loaded. Manual reviews are still visible.', true);
    } finally {
      clearTimeout(timeout);
      section.dataset.plReviews2Loading = 'false';
    }
  }

  function setupScrolling(section) {
    var viewport = section.querySelector('[data-pl-reviews-2-viewport]');
    if (!viewport || viewport.dataset.plReviews2Ready === 'true') return;
    viewport.dataset.plReviews2Ready = 'true';
    var previous = section.querySelector('[data-pl-reviews-2-prev]');
    var next = section.querySelector('[data-pl-reviews-2-next]');
    var step = function () { return Math.max(260, viewport.clientWidth * 0.72); };
    if (previous) previous.addEventListener('click', function () { viewport.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { viewport.scrollBy({ left: step(), behavior: 'smooth' }); });

    var dragging = false;
    var originX = 0;
    var originScroll = 0;
    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      originX = event.clientX;
      originScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', function (event) {
      if (dragging) viewport.scrollLeft = originScroll - (event.clientX - originX);
    });
    var stopDragging = function () { dragging = false; viewport.classList.remove('is-dragging'); };
    viewport.addEventListener('pointerup', stopDragging);
    viewport.addEventListener('pointercancel', stopDragging);
    viewport.addEventListener('wheel', function (event) {
      var delta = event.shiftKey ? event.deltaY || event.deltaX : event.deltaX || event.deltaY;
      if (!delta) return;
      event.preventDefault();
      viewport.scrollLeft += delta;
    }, { passive: false });

    var config = readConfig(section);
    var reducedMotion = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!config.autoplay || reducedMotion) return;
    var paused = false;
    var timer = setInterval(function () {
      if (paused || document.hidden) return;
      var atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 8;
      viewport.scrollTo({ left: atEnd ? 0 : viewport.scrollLeft + step(), behavior: 'smooth' });
    }, config.interval);
    section.addEventListener('mouseenter', function () { paused = true; });
    section.addEventListener('mouseleave', function () { paused = false; });
    section.addEventListener('focusin', function () { paused = true; });
    section.addEventListener('focusout', function () { paused = false; });
    section.addEventListener('pointerdown', function () { paused = true; }, { once: true });
    section.addEventListener('shopify:block:select', function () { paused = true; });
    section.addEventListener('shopify:section:unload', function () { clearInterval(timer); }, { once: true });
  }

  function setupSection(section) {
    setupScrolling(section);
    var retry = section.querySelector('[data-pl-reviews-2-retry]');
    if (retry) retry.addEventListener('click', function () { loadJudgeMe(section, true); });
    if (typeof IntersectionObserver === 'undefined') {
      loadJudgeMe(section, false);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      loadJudgeMe(section, false);
    }, { rootMargin: '500px 0px' });
    observer.observe(section);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pl-reviews-2]').forEach(setupSection);
  }

  var api = { buildJudgeMeUrl: buildJudgeMeUrl, selectAutomaticReviews: selectAutomaticReviews, extractJudgeMeReviews: extractJudgeMeReviews };
  root.PLReviews2 = api;
  if (typeof document !== 'undefined' && !root.__PL_REVIEWS_2_TEST__) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
